import type { AuthProvider } from '@refinedev/core'

import { saveReturnTo } from '@/auth/returnTo'
import { authService } from '@/services/authService'
import { userService } from '@/services/userService'

function clearSession(): void {
  authService.logout()
  // Also drop unrelated client state (theme prefs, filters, etc.) on sign-out.
  localStorage.clear()
  sessionStorage.clear()
}

export const authProvider: AuthProvider = {
  login: async () => ({ success: true }),

  logout: async () => {
    clearSession()
    return { success: true, redirectTo: '/login' }
  },

  check: async () => {
    if (window.location.pathname === '/auth/callback') {
      return { authenticated: true }
    }
    try {
      await authService.getTokens()
      return { authenticated: true }
    } catch {
      return { authenticated: false, redirectTo: '/login' }
    }
  },

  getPermissions: async () => {
    try {
      const { accessToken } = await authService.getTokens()
      return accessToken.permissions
    } catch {
      return []
    }
  },

  getIdentity: async () => {
    const user = userService.getCurrentUser()
    if (!user) return null
    return { id: user.id, name: user.email, email: user.email }
  },

  onError: async (error) => {
    if (error?.statusCode === 401) {
      const { pathname, search } = window.location
      clearSession()
      // Session died mid-route — offer the same place back after re-login.
      saveReturnTo(pathname, search)
      return { logout: false, redirectTo: '/login' }
    }
    return { error }
  },
}
